import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import activityReducer from '../components/Activity/ActivitySlice';
import clickOutsideReducer from '../components/ClickOutside/ClickOutsideSlice';
import commentsReducer from '../components/Comments/CommentsSlice';
import channelsReducer from '../components/Channels/ChannelsSlice';
import checkoutReducer from '../components/Checkout/CheckoutSlice';
import creatorsReducer from '../components/Creators/CreatorsSlice';
import itemsReducer from '../components/Items/ItemsSlice';
import rebuzzReducer from '../components/Rebuzz/RebuzzSlice';
import loginFormReducer from '../components/Login/Form/LoginFormSlice';
import messengerReducer from '../components/Messenger/MessengerSlice';
import organizationsReducer from '../components/Organizations/OrganizationsSlice';
import profileReducer from '../components/Profile/ProfileSlice';
import recentReducer from '../components/Recents/RecentsSlice';
import registerFormReducer from '../components/Register/RegisterSlice';
import rolesReducer from '../components/Roles/RolesSlice';
import searchReducer from '../components/Search/SearchSlice';
import settingsReducer from '../components/Settings/SettingsSlice';
import sidebarFacetsReducer from '../components/Sidebar/Facets/SidebarFacetsSlice';
import streamsReducer from '../components/Streams/StreamsSlice';
import schedulingReducer from '../components/Scheduling/SchedulingSlice';
import suggestedReducer from '../components/Suggested/SuggestedSlice';
import topicsReducer from '../components/TopicTags/TopicsSlice';
import uiReducer from './ui/UiSlice';
import usersReducer from '../components/Users/UsersSlice';
import jobReducer from '../components/Item/Job/JobSlice';

const authReducer = combineReducers({
  login: loginFormReducer,
  register: registerFormReducer,
});

export default configureStore({
  reducer: {
    activity: activityReducer,
    auth: authReducer,
    channels: channelsReducer,
    clickOutside: clickOutsideReducer,
    checkout: checkoutReducer,
    currentUser: profileReducer,
    comments: commentsReducer,
    creators: creatorsReducer,
    items: itemsReducer,
    messenger: messengerReducer,
    organizations: organizationsReducer,
    rebuzz: rebuzzReducer,
    recent: recentReducer,
    search: searchReducer,
    settings: settingsReducer,
    sidebarFacets: sidebarFacetsReducer,
    streams: streamsReducer,
    scheduling: schedulingReducer,
    roles: rolesReducer,
    suggested: suggestedReducer,
    topics: topicsReducer,
    ui: uiReducer,
    users: usersReducer,
    job: jobReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      immutableCheck: { warnAfter: 128 },
      serializableCheck: { warnAfter: 128 },
    }),
});
